import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgVoorschotStookkostenWijzigen = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#D9F4D8"
      d="M24.03 16.02c3.97 3.97 4.92 9.83 1.7 13.04-3.21 3.21-9.04 2.6-13.01-1.37l11.3-11.67z"
    />
    <path
      fill="#60D15D"
      d="M11.79 16.9c.34-.46 1.06-.21 1.1.36.09 1.2.61 2.85 2.54 4.14 0 0-3.1-10.35 4.47-15.3.37-.24.84.11.72.53-.37 1.31-.47 3.46 1.68 5.61 3.4 3.4 7.92 5.68 8.01 11.28.08 5.13-3.45 9.48-8.51 10.31-6.52 1.07-12.08-3.85-12.08-10.15 0 0 .09-4.14 2.08-6.79zm6.32 9.96c-.72.55-1.58 1.02-2.56 1.28-.55.15-.65.87-.2 1.21a7.44 7.44 0 0 0 5.81 1.42c3.11-.52 5.62-3.06 6.11-6.18.51-3.29-1.12-6.24-3.71-7.71.61 1.09.97 2.34.97 3.68 0 3.08-1.86 5.72-4.51 6.87-.12.05 1.87-1.58.89-5.04-.73 2.4-1.44 3.43-2.8 4.46z"
    />
    <path
      fill="#00215B"
      d="M22.77 17.61c-3.2-3.2-3.2-8.41 0-11.6l.71.71a7.21 7.21 0 0 0 0 10.19l-.71.71zM12.35 23.96c-1.2-1.2-1.87-2.8-1.87-4.51s.66-3.3 1.87-4.51l.71.71c-2.09 2.09-2.09 5.5 0 7.6z"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgVoorschotStookkostenWijzigen);

export default ForwardRef;
